// tslint:disable:max-line-length
import * as React from 'react'

import { DiagonalCrop } from '@doordash/component-diagonal'
import MediaQuery from 'react-responsive'
import {
  ChildrenWrapper,
  CityState,
  HeroContent,
  Root,
  TextContainer,
  Title,
  VideoContainer,
} from './styles'

import { Text, Breakpoints, StackChildren } from '@doordash/design-language'

import {
  AWS_BASE,
  CLOUDFLARE_DEFAULT_BASE,
  JOB_TYPES,
  JOBS,
} from '../../../constants'
import HeroStrings from './strings'

type Props = {
  cityState: string
  jobType: string
  datePosted: string
}

const getTitle = (cityState, jobType) => {
  if (jobType) {
    return mapJobTypeToString(jobType)
  }
  return cityState
    ? HeroStrings.heroTitleCity()
    : HeroStrings.heroTitleDefault()
}

const mapJobTypeToString = jobType => {
  for (const idx in JOB_TYPES) {
    if (jobType === JOB_TYPES[idx]) {
      return `${JOBS[idx]} opportunity`
    }
  }
  return HeroStrings.heroTitleDefault()
}

const getHeroContent = (cityState, jobType, datePosted) => {
  if (jobType) {
    return `Posted on ${datePosted}`
  }

  return cityState
    ? HeroStrings.heroContentCity(cityState)
    : HeroStrings.heroContentDriving()
}

const DrivingOpportunitiesHero: React.SFC<Props> = ({
  cityState,
  jobType,
  datePosted,
  children,
}) => (
  <Root>
    <TextContainer>
      <StackChildren>
        <CityState
          mobileStyles={{ ...Text.Styles.Bold16, size: 20 }}
          styles={{ ...Text.Styles.Bold24, size: 28 }}
        >
          {cityState}
        </CityState>
        <Title
          mobileStyles={{ ...Text.Styles.Bold40, size: 40 }}
          tabletStyles={Text.Styles.Bold40}
          styles={{ ...Text.Styles.Bold40, size: 60 }}
        >
          {getTitle(cityState, jobType)}
        </Title>
        <HeroContent
          mobileStyles={{ ...Text.Styles.PageDescriptionBody, size: 20 }}
          tabletStyles={Text.Styles.PageDescriptionBody}
          styles={{ ...Text.Styles.PageDescriptionBody, size: 20 }}
        >
          {getHeroContent(cityState, jobType, datePosted)}
        </HeroContent>
      </StackChildren>
    </TextContainer>
    <MediaQuery minWidth={Breakpoints.Mobile}>
      <VideoContainer>
        <DiagonalCrop
          side={DiagonalCrop.Sides.Right}
          width="100vw"
          height="100%"
          angle={45}
          shouldAnimate={true}
          alt={''}
          src={`${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-header-pattern-desktop%402x.png`}
          srcSet={`${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-header-pattern-desktop%402x.png`}
          fallbackSrc={`${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/city-page-header-pattern-desktop%402x.png`}
        />
      </VideoContainer>
    </MediaQuery>
    <ChildrenWrapper alignChildren="center">{children}</ChildrenWrapper>
  </Root>
)

export default DrivingOpportunitiesHero
